import axios from "axios";

const useLocalhost = false;
const prodUrl = "https://saapapi.scatterblue.com/v1";

const TANANT_ID = "saapdev";
const CLIENT_ID = "smartstore";
const ALGO_ENC_HASH = 6;

const axiosClientIam = axios.create({
  baseURL: useLocalhost ? "http://localhost:3101" : `${prodUrl}/iam`,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Add a response interceptor
axiosClientIam.interceptors.response.use(
  (response) => {
    return response.data.Data;
  },
  (error) => {
    return Promise.reject(error); // Always return a rejected Promise in case of error
  },
);

// Add a request interceptor so that the current token (if set) is sent with every request
axiosClientIam.interceptors.request.use(
  (config) => {
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

const axiosClientSaa = axios.create({
  baseURL: useLocalhost ? "http://localhost:3100" : `${prodUrl}/saa`,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Add a response interceptor
axiosClientSaa.interceptors.response.use(
  (response) => {
    return response.data.Data;
  },
  (error) => {
    return Promise.reject(error); // Always return a rejected Promise in case of error
  },
);

// request interceptor for token
axiosClientSaa.interceptors.request.use(
  (config) => {
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

var token = null;

class HttpService {
  /**
   * globally update token and apply to both axios clients
   */
  setToken(newToken) {
    token = newToken;
    axiosClientIam.defaults.headers.common["Authorization"] = token;
    axiosClientSaa.defaults.headers.common["Authorization"] = token;
  }

  async login(user, password) {
    let resp = await axiosClientIam.post("/auth/login", {
      tenantId: TANANT_ID,
      clientId: CLIENT_ID,
      username: user,
      password: password,
    });
    console.log("TOKEN SET:", resp);
    this.setToken(`Bearer ${resp.accessToken}`);
  }

  async loginWithOtp(phoneNumber, otp) {
    let resp = await axiosClientIam.post("/auth/login", {
      tenantId: TANANT_ID,
      clientId: CLIENT_ID,
      username: phoneNumber,
      otp: otp || "",
    });
    console.log("TOKEN SET:", JSON.stringify(resp));
    if (resp.accessToken) {
      this.setToken(`Bearer ${resp.accessToken}`);
    }
  }

  async requestToken(sdkCode, pin) {
    let resp = await axiosClientSaa.post("/store/emg-token", {
      pinCode: pin,
      sdkCode: sdkCode,
      algoType: ALGO_ENC_HASH,
    });

    console.log("TOKRESP:", resp);
    if (!resp || !resp.orderId) {
      return null; // failed to get token, likely due to wrong PIN
    }

    // Already have token for this order, reuse it not unlocked before
    if (!resp.token) {
      const storedToken = localStorage.getItem(`lkrm-tok-${resp.orderId}`);
      console.log("Retrive Stored Token", storedToken);
      resp.token = storedToken;
    } else {
      localStorage.setItem(`lkrm-tok-${resp.orderId}`, resp.token);
    }

    console.log("Unlock Token", resp);
    return resp;
  }

  /**
   * Post with url encoded data
   * @param url
   * @param options
   * @returns
   */

  async get(url, params, hdrs) {
    return await axiosClientSaa.get(url, {
      params: params,
      headers: { Authorization: token },
    });
  }

  async post(url, data, hdrs) {
    console.log("TOKEN:", token);
    return await axiosClientSaa.post(url, data, {
      headers: { Authorization: token },
    });
  }
}

export default HttpService;
